/**
 * Returns the lowercase extension of a file name, e.g. "pptx" for "Report_DE.PPTX".
 * Returns undefined if the file name has no extension.
 */
export function getFileExtension(fileName: string) {
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex <= 0 || dotIndex === fileName.length - 1) {
    return undefined;
  }
  return fileName.slice(dotIndex + 1).toLowerCase();
}
